import AutocompleteDropdown from 'componentes/generic/AutoComplete.js';
import WizardInput from 'componentes/wizard/WizardInput.js';
import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
const URIAdmin = ApiEndpoint + 'administration/';

import PropTypes from 'prop-types';
import MyModal from 'helpers/MyModal.js';
import EditClasificacionQueja from 'pages/Administration/_EditClasificacionQueja.js';
import EditFormatoQueja from 'pages/Administration/_EditFormatoQueja.js';

import EditClasificacionQuejaWm from 'pages/Administration/_EditClasificacionQuejaWm';
import { Controller } from 'react-hook-form';
import { useQuejaWizardContext } from 'context/QuejaWizardProvider';
import IconButton from 'componentes/common/IconButton';
const QuejaData = ({ register, errors, setValue, control }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();

  const [openFormatoQueja, setOpenFormatoQueja] = useState('');
  const [openModalClasificacionQueja, setOpenModalClasificacionQueja] =
    useState(false);
  const [openModalClasificacionQuejaWm, setOpenModalClasificacionQuejaWm] =
    useState(false);
  const [clasificacionesQueja, setClasificacionesQueja] = useState(null);
  const [clasificacionesQuejaWm, setClasificacionesQuejaWm] = useState(null);
  const [clasificacionesQuejaProfeco, setClasificacionesQuejaProfeco] =
    useState(null);
  const [formatosQueja, setFormatosQueja] = useState(null);
  const {
    selectedClasificacionDescription,
    setSelectedClasificacionDescription,
    selectedClasificacionWmDescription,
    setSelectedClasificacionWmDescription,
    selectedClasificacionProfecoDescription,
    setSelectedClasificacionProfecoDescription,
    formatoQuejaSelected,
    setFormatoQuejaSelected,
    queja
  } = useQuejaWizardContext();
  const handleCloseClasificacionQueja = () => {
    setOpenModalClasificacionQueja(false);
    getClasificacionesQueja();
  };
  const handleCloseClasificacionQuejaWm = () => {
    setOpenModalClasificacionQuejaWm(false);
    getClasificacionesQuejaWm();
  };
  const handleCloseFormatoQueja = () => {
    setOpenFormatoQueja(false);
    getFormatosQueja();
  };

  const getClasificacionesQuejaWm = async () => {
    setClasificacionesQuejaWm(null);

    httpClient('GET', URIAdmin + 'clasificationswm/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var deleg = response.data.map(item => {
            return {
              id: item.idclasificacionquejawm,
              description: `${item.clave}/${item.descripcion}`
            };
          });
          setClasificacionesQuejaWm(deleg);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  const getClasificacionesQueja = async () => {
    setClasificacionesQueja(null);

    httpClient('GET', URIAdmin + 'clasifications/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var deleg = response.data.map(item => {
            return {
              id: item.idclasificacionqueja,
              description: `${item.clave}/${item.descripcion}`
            };
          });
          setClasificacionesQueja(deleg);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  const getClasificacionesQuejaProfeco = async () => {
    setClasificacionesQuejaProfeco(null);

    httpClient('GET', URIAdmin + 'clasificationsprofeco/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var clasificaciones = response.data.map(item => {
            return {
              id: item.idclasificacionquejaprofeco,
              description: `${item.descripcion}`
            };
          });
          setClasificacionesQuejaProfeco(clasificaciones);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getFormatosQueja = async () => {
    setFormatosQueja(null);

    httpClient('GET', URIAdmin + 'formatosqueja/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var tiposPlataforma = response.data.map(item => {
            return { value: item.idformatoqueja, label: item.formato };
          });
          setFormatosQueja(tiposPlataforma);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    if (!clasificacionesQuejaWm) getClasificacionesQuejaWm();
    if (!clasificacionesQueja) getClasificacionesQueja();
    if (!formatosQueja) getFormatosQueja();
    if (!clasificacionesQuejaProfeco) getClasificacionesQuejaProfeco();
  }, []);
  return (
    <>
      <Row className="g-2 mb-3">
        <Col>
          {clasificacionesQueja && (
            <AutocompleteDropdown
              items={clasificacionesQueja}
              placeholder="Selecciona una clasificacion de queja"
              currentSelected={selectedClasificacionDescription}
              name="clasificacionQueja"
              register={register}
              errors={errors}
              setValue={setValue}
              addFunction={() => {
                setOpenModalClasificacionQueja(true);
              }}
              addButton={true}
              setCurrentSelected={value => {
                setSelectedClasificacionDescription(value.description);
              }}
            />
          )}
        </Col>
      </Row>{' '}
      <Row className="g-2 mb-3">
        <Col>
          {clasificacionesQuejaProfeco && (
            <AutocompleteDropdown
              items={clasificacionesQuejaProfeco}
              placeholder="Selecciona una clasificacion de queja (Profeco)"
              currentSelected={selectedClasificacionProfecoDescription}
              name="clasificacionQuejaProfeco"
              register={register}
              errors={errors}
              setValue={setValue}
              addButton={false}
              setCurrentSelected={value => {
                setSelectedClasificacionProfecoDescription(value.descripcion);
              }}
            />
          )}
        </Col>
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          {clasificacionesQuejaWm && (
            <AutocompleteDropdown
              items={clasificacionesQuejaWm}
              placeholder="Selecciona una clasificacion de queja (Walmart)"
              currentSelected={selectedClasificacionWmDescription}
              name="clasificacionQuejawm"
              register={register}
              errors={errors}
              setValue={setValue}
              addFunction={() => {
                setOpenModalClasificacionQuejaWm(true);
              }}
              addButton={true}
              setCurrentSelected={value => {
                setSelectedClasificacionWmDescription(value.description);
              }}
            />
          )}
        </Col>
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          <Controller
            name="idCustomer"
            control={control}
            rules={{ required: true }}
            render={() => (
              <WizardInput
                label="Fecha de Queja"
                name="fechaqueja"
                type="date"
                value={queja.fechaqueja}
                errors={errors}
                setValue={setValue}
                formGroupProps={{ className: 'mb-3' }}
                formControlProps={{
                  ...register('fechaqueja', { required: true })
                }}
              />
            )}
          />
        </Col>
        <Col>
          <WizardInput
            label="Fecha de Recepcion"
            name="fecharecepcion"
            type="date"
            errors={errors}
            setValue={setValue}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('fecharecepcion', { required: true })
            }}
          />
        </Col>
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          <Controller
            name="fechacompra"
            control={control}
            rules={{ required: true }}
            render={() => (
              <WizardInput
                label="Fecha de Compra"
                name="fechacompra"
                type="date"
                value={queja.fechacompra}
                errors={errors}
                setValue={setValue}
                formGroupProps={{ className: 'mb-3' }}
                formControlProps={{
                  ...register('fechacompra', { required: true })
                }}
              />
            )}
          />
        </Col>
        <Col>
          <WizardInput
            label="Fecha de Devolucion"
            name="fechadevolucion"
            type="date"
            errors={errors}
            setValue={setValue}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('fechadevolucion', { required: true })
            }}
          />
        </Col>
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          <IconButton
            variant="outline-secondary"
            size="sm"
            icon="plus"
            style={{ float: 'right', marginRight: '5px', fontSize: 'smallest' }}
            transform="shrink-3"
            onClick={() => setOpenFormatoQueja(true)}
          >
            Agregar
          </IconButton>
          {formatosQueja && (
            <WizardInput
              label="Formato de Queja"
              type="select"
              name="formatoqueja"
              errors={errors}
              value={formatoQuejaSelected}
              options={formatosQueja}
              onChange={e => {
                console.log(e.target.value);
                setFormatoQuejaSelected(e.target.value);
              }}
              formGroupProps={{ className: 'mb-3' }}
              formControlProps={{
                ...register('formatoqueja', { required: true })
              }}
            />
          )}
        </Col>
        <Col>
          <WizardInput
            label="Folio Oracle"
            name="folioext"
            errors={errors}
            formGroupProps={{ className: 'mb-3' }}
            mask="folioext"
            formControlProps={{
              ...register('folioext', { required: true })
            }}
          />
        </Col>
        <Col>
          <Controller
            name="anio"
            control={control}
            rules={{ required: true }}
            render={field => (
              <WizardInput
                label="Año"
                type="inputmask"
                value={field.value}
                onChange={field.onChange}
                mask="9999"
                name="anio"
                errors={errors}
                formGroupProps={{ className: 'mb-3' }}
                formControlProps={{
                  ...register('anio', { required: true })
                }}
              />
            )}
          />
        </Col>
      </Row>
      {/* <Row className="g-2 mb-3">
        <WizardInput
          label="Descripcion de la Queja"
          name="descripcionqueja"
          type="textarea"
          errors={errors}
          formGroupProps={{ className: 'mb-3' }}
          formControlProps={{
            ...register('descripcionqueja', { required: true })
          }}
        />
      </Row> */}
      {/* <Row className="g-2 mb-3">
        <WizardInput
          label="Descripcion Walmart"
          name="descripcionwalmart"
          type="textarea"
          errors={errors}
          formGroupProps={{ className: 'mb-3' }}
          formControlProps={{
            ...register('descripcionwalmart', { required: true })
          }}
        />
      </Row> */}
      {openModalClasificacionQueja && (
        <MyModal
          id="id_myModal"
          title={'Editar Clasificacion'}
          openModal={openModalClasificacionQueja}
          closeModal={handleCloseClasificacionQueja}
        >
          <EditClasificacionQueja
            closeModal={handleCloseClasificacionQueja}
            idClasificacionQueja={0}
          ></EditClasificacionQueja>
        </MyModal>
      )}
      {openModalClasificacionQuejaWm && (
        <MyModal
          id="id_myModal"
          title={'Editar Clasificacion'}
          openModal={openModalClasificacionQuejaWm}
          closeModal={handleCloseClasificacionQuejaWm}
        >
          <EditClasificacionQuejaWm
            closeModal={handleCloseClasificacionQuejaWm}
            idClasificacionQueja={0}
          ></EditClasificacionQuejaWm>
        </MyModal>
      )}
      {openFormatoQueja && (
        <MyModal
          id="id_myModal"
          title={'Agregar Formato de Queja'}
          openModal={openFormatoQueja}
          closeModal={handleCloseFormatoQueja}
        >
          <EditFormatoQueja
            closeModal={handleCloseFormatoQueja}
            idFormatosQueja={0}
          ></EditFormatoQueja>
        </MyModal>
      )}
    </>
  );
};
QuejaData.propTypes = {
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func,
  errors: PropTypes.object,
  watch: PropTypes.func,
  control: PropTypes.object
};
export default QuejaData;
